import { useState } from "react";
import { Col, Button, Modal, Form, Row } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import {
  PLEASE_ENTER_FARM_NAME,
  PLEASE_SELECT_BUSINESS,
  PLEASE_ENTER_BUSINESS_NAME,
  FARM_NAME_ALREADY_EXISTS,
  BUSINESS_NAME_ALREADY_EXISTS,
  LABEL_ENTER_FARM_NAME,
  LABEL_ENTER_BUSINESS_NAME,
  LABEL_SELECT_BUSINESS,
  ADD_FARM_AND_BUSINESS,
  NEW_FARM,
  NEW_BUSINESS,
} from "configurations/MessageConstants";

function FarmBusinessPopup({
  showFarmModal,
  businessList,
  farmBusinessList,
  onAdd,
  onClose,
}) {
  const [isNewBusiness, setIsNewBusiness] = useState(false);

  const defaultValues = {
    farm: "",
    business: "",
    newBusiness: "",
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues });

  const onSubmit = (data) => {
    const farmData = {
      farm: data.farm,
      business: isNewBusiness ? data.newBusiness : data.business,
    };
    onAdd(farmData);
    handleClose();
  };

  const handleClose = () => {
    reset(defaultValues);
    setIsNewBusiness(false);
    onClose();
  };

  const handleNewBusinessClick = () => {
    setIsNewBusiness(true);
    setValue("business", "");
  };

  return (
    <>
      <Modal
        show={showFarmModal}
        onHide={handleClose}
        size="md"
        centered
        animation={false}
        aria-labelledby="farm-and-business-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="farm-and-business-popup">
            {ADD_FARM_AND_BUSINESS}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <Row className="g-4 mb-3">
              <Col>
                <Form.Group controlId="formFarmName">
                  <Form.Label>{NEW_FARM}</Form.Label>
                  <Controller
                    name="farm"
                    control={control}
                    rules={{
                      required: PLEASE_ENTER_FARM_NAME,
                      validate: (value) => {
                        const farmExists = farmBusinessList.some(
                          (farm) =>
                            farm.farmName.toLowerCase() === value.toLowerCase()
                        );
                        return !farmExists || FARM_NAME_ALREADY_EXISTS;
                      },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        className="input-underline"
                        type="text"
                        placeholder={LABEL_ENTER_FARM_NAME}
                        isInvalid={!!errors.farm}
                        maxLength={50}
                      />
                    )}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.farm?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="g-4 mb-3">
              <Col>
                <Form.Group controlId="formBusiness">
                  <Form.Label className="d-flex justify-content-between">
                    <span>Business</span>
                    <Button
                      variant="link"
                      className="new-business-button"
                      onClick={handleNewBusinessClick}
                      disabled={isNewBusiness}
                      type="button"
                    >
                      <i className="fa-solid fa-circle-plus me-1" />
                      <small>{NEW_BUSINESS}</small>
                    </Button>
                  </Form.Label>
                  <Controller
                    name="business"
                    control={control}
                    rules={{
                      required: !isNewBusiness ? PLEASE_SELECT_BUSINESS : false,
                    }}
                    render={({ field }) => (
                      <Form.Select
                        {...field}
                        className="input-underline"
                        aria-label="Select Business"
                        isInvalid={!!errors.business}
                        disabled={isNewBusiness}
                      >
                        <option value="">{LABEL_SELECT_BUSINESS}</option>
                        {[...new Set(businessList)].map((business) => (
                          <option key={business} value={business}>
                            {business}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.business?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {isNewBusiness && (
              <Row className="g-4 mb-3">
                <Col>
                  <Form.Group controlId="formNewBusinessName">
                    <Form.Label>{NEW_BUSINESS}</Form.Label>
                    <Controller
                      name="newBusiness"
                      control={control}
                      rules={{
                        required: isNewBusiness
                          ? PLEASE_ENTER_BUSINESS_NAME
                          : false,
                        validate: (value) => {
                          const businessExists = businessList.includes(value);
                          return (
                            !businessExists || BUSINESS_NAME_ALREADY_EXISTS
                          );
                        },
                      }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          className="input-underline"
                          type="text"
                          placeholder={LABEL_ENTER_BUSINESS_NAME}
                          isInvalid={!!errors.newBusiness}
                          maxLength={50}
                        />
                      )}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.newBusiness?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FarmBusinessPopup;
